import React, { ReactNode, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { View } from "@com.mgmtp.a12.client/client-core/lib/core/view";
import { ButtonGroup } from "@com.mgmtp.a12.widgets/widgets-core/lib/button-group/main/button-group.view";
import { Button } from "@com.mgmtp.a12.widgets/widgets-core/lib/button/main/button.view";
import { ActionContentbox } from "@com.mgmtp.a12.widgets/widgets-core/lib/contentbox/main/action-contentbox/action-contentbox.view";
import { ContentBoxElements } from "@com.mgmtp.a12.widgets/widgets-core/lib/contentbox/main/template/contentbox.tpl.view";
import { DefaultFileUpload } from "@com.mgmtp.a12.widgets/widgets-core/lib/file-upload/main/default/default-file-upload.view";
import { ButtonGroupContainer } from "@com.mgmtp.a12.widgets/widgets-core/lib/layout/button-group-container/main/button-group-container.view";

import { importFileActionCreator } from "../sagas/actions";

const ACCEPTED_FILE_TYPES = "text/xml,application/xml,application/json,.xml,.json";

export function FileDialog(props: View): ReactNode {
	const [importFile, setImportFile] = useState<File | null>(null);
	const dispatch = useDispatch();

	const activityId = props.activityId;
	const parentActivityId = useSelector(
		ActivitySelectors.activityPropById(props.activityId, it => it.initiatingActivityId)
	);

	const onCancelButtonClick = React.useCallback(() => {
		dispatch(ActivityActions.cancel({ activityId }));
	}, [dispatch, activityId]);

	const onOkButtonClick = React.useCallback(() => {
		if (parentActivityId && importFile) {
			dispatch(
				importFileActionCreator({
					mainActivityId: parentActivityId,
					modalActivityId: activityId,
					importFile
				})
			);
		}
	}, [dispatch, activityId, parentActivityId, importFile]);

	const onFileChange = React.useCallback(
		(fileList: FileList): void => {
			setImportFile(fileList.item(0));
		},
		[setImportFile]
	);

	const fullWidthStyle = {
		width: "100%"
	};

	return (
		<ActionContentbox
			headingElements={<ContentBoxElements.Title text="Antragsdaten einlesen" ariaLevel={2} />}
			ariaLabel="Dateiauswahl zum Einlesen von Antragsdaten"
			footer={
				<ContentBoxElements.Footer>
					<ButtonGroupContainer>
						<ButtonGroup alignment="right">
							<Button label="Abbrechen" destructive secondary onClick={onCancelButtonClick} />
							<Button label="OK" primary disabled={importFile === null} onClick={onOkButtonClick} />
						</ButtonGroup>
					</ButtonGroupContainer>
				</ContentBoxElements.Footer>
			}
		>
			<DefaultFileUpload
				uploadAreaSize={fullWidthStyle}
				accept={ACCEPTED_FILE_TYPES}
				helperText="Dateiformat XML oder JSON"
				descriptionText={
					importFile !== null
						? `Sie haben die Datei "${importFile.name}" ausgewählt.`
						: "Sie können hier die Datei reinziehen oder "
				}
				buttonText="Hochladen"
				onChange={onFileChange}
			/>
		</ActionContentbox>
	);
}
